import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FFF8F0]">
      {/* Header */}
      <header className="bg-white shadow-sm py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#FF6B00] hover:text-[#E65C00] transition-colors">
            <ArrowLeft size={20} />
            <span className="font-medium">Back to Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-black text-[#1A1C19] mb-8" style={{ fontFamily: "Fraunces, serif" }}>
          Privacy Policy
        </h1>
        
        <div className="prose prose-lg max-w-none text-[#4A5043]">
          <p className="text-sm text-gray-500 mb-8">Last Updated: February 2025</p>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">1. Introduction</h2>
            <p className="mb-4">
              Welcome to our website. We respect your privacy and are committed to protecting your personal data. 
              This privacy policy will inform you about how we look after your personal data when you visit our 
              website and tell you about your privacy rights and how the law protects you.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">2. Information We Collect</h2>
            <p className="mb-4">We may collect, use, store and transfer different kinds of personal data about you, including:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li><strong>Identity Data:</strong> First name, last name, username or similar identifier</li>
              <li><strong>Contact Data:</strong> Email address and telephone numbers</li>
              <li><strong>Technical Data:</strong> Internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform</li>
              <li><strong>Usage Data:</strong> Information about how you use our website and products</li>
              <li><strong>Marketing Data:</strong> Your preferences in receiving marketing from us</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">3. How We Use Your Information</h2>
            <p className="mb-4">We use your personal data for the following purposes:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>To register you as a new customer</li>
              <li>To process and deliver your order</li>
              <li>To manage our relationship with you</li>
              <li>To improve our website, products, and services</li>
              <li>To recommend products or services that may interest you</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">4. Data Security</h2>
            <p className="mb-4">
              We have implemented appropriate security measures to prevent your personal data from being accidentally 
              lost, used, or accessed in an unauthorized way, altered, or disclosed. We limit access to your personal 
              data to those employees, agents, contractors, and other third parties who have a business need to know.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">5. Cookies</h2>
            <p className="mb-4">
              Our website uses cookies to distinguish you from other users. This helps us provide you with a good 
              experience when you browse our website and also allows us to improve our site. You can set your browser 
              to refuse all or some browser cookies, or to alert you when websites set or access cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">6. Third-Party Links</h2>
            <p className="mb-4">
              Our website may include links to third-party websites, plug-ins, and applications. Clicking on those 
              links or enabling those connections may allow third parties to collect or share data about you. We do 
              not control these third-party websites and are not responsible for their privacy statements.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">7. Your Legal Rights</h2>
            <p className="mb-4">Under certain circumstances, you have rights under data protection laws, including:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>The right to access your personal data</li>
              <li>The right to correction of your personal data</li>
              <li>The right to erasure of your personal data</li>
              <li>The right to object to processing of your personal data</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">8. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <p className="mb-4">
              <Link to="/contact" className="text-[#FF6B00] hover:underline">Visit our Contact Page</Link>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">9. Changes to This Policy</h2>
            <p className="mb-4">
              We may update this privacy policy from time to time. We will notify you of any changes by posting 
              the new privacy policy on this page and updating the "Last Updated" date at the top of this policy.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1A1C19] text-white py-6 text-center text-sm">
        <p>© {new Date().getFullYear()} All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
